<template>
  <div class="page-content">

    <Staff v-if="!$hasOneOfRoles('Customer', 'Engineer')"></Staff>
    <EngineerDashboard v-else-if="$hasRole('Engineer')"></EngineerDashboard>
    <CustomerDashboard v-else></CustomerDashboard>

  </div>
</template>

<script>
import Staff from './Staff.vue'
import EngineerDashboard from './Engineer.vue'
import CustomerDashboard from './Customer.vue'
export default {
  name: "Dashboard",
  components: {
    Staff,
    CustomerDashboard,
    EngineerDashboard
  },
  mounted(){
    console.log(this.$store.state.auth);
  }
}
</script>

